import { useTranslation } from "react-i18next";
import { localDateTime } from "../../lib/datetime";
import { BadgeCheck, ShieldAlert, ShieldOff } from "lucide-react";
import { sealQrUrl } from "../../api/verify";
import { localPick } from "../../lib/localName";

const TONE = {
  sealed: ["text-primary", BadgeCheck],
  unsealed: ["text-amber-500", ShieldAlert],
  unknown: ["text-destructive", ShieldOff],
};

// نتيجة التحقق من بصمة تقرير مختوم — بيانات الحالة فقط بلا أي مبالغ.
export const SealVerifyResult = ({ result }) => {
  const { t, i18n } = useTranslation();
  const [tone, Icon] = TONE[result.status] || TONE.unknown;
  const company = localPick(result, "company_name");
  const rows = [
    ["verify.company", company],
    ["verify.month", result.month],
    ["verify.period", result.period_start ? `${result.period_start} → ${result.period_end}` : null],
    ["verify.branch", result.branch_name],
    ["verify.employees", result.employees],
    ["verify.sealedAt", localDateTime(result.sealed_at)],
    ["verify.paidAt", (result.paid_at || "").slice(0, 10)],
  ].filter(([, value]) => value !== null && value !== undefined && value !== "");

  return (
    <div data-testid="verify-result">
      <p className={`flex items-center gap-2 text-lg font-black ${tone}`} data-testid={`verify-status-${result.status}`}>
        <Icon className="h-6 w-6" /> {t(`verify.status.${result.status}`)}
      </p>
      <p className="mt-3 break-all rounded-2xl p-3 font-mono text-xs shadow-neu-in" dir="ltr"
        data-testid="verify-hash">
        {result.hash}
      </p>
      {result.found ? (
        <>
          <dl className="mt-5 grid gap-2 text-sm">
            {rows.map(([key, value]) => (
              <div key={key} className="flex items-center justify-between gap-3 border-b border-border/40 pb-2">
                <dt className="text-xs text-muted-foreground">{t(key)}</dt>
                <dd className="font-bold" dir="auto">{value}</dd>
              </div>
            ))}
          </dl>
          <img src={sealQrUrl(result.hash)} alt="QR" className="mt-6 h-32 w-32 rounded-2xl bg-white p-2 shadow-neu-in"
            data-testid="verify-qr" />
        </>
      ) : (
        <p className="mt-4 text-sm text-muted-foreground" data-testid="verify-not-found">{t("verify.notFoundHint")}</p>
      )}
    </div>
  );
};
